import React from "react";

import { Paper, Typography } from "@mui/material";

/**
 * Formatted MUI component:
 *
 * Title
 * Value
 */
export default function PaperFragment(props) {
    const title = props.title;
    const value = props.value;

    return (
        <Paper
            elevation={props.elevation}
            className={props.className}
            sx={{
                p: props.p ?? 1,
                m: props.m ?? 1,
                display: "flex",
                flexDirection: props.flexDirection ?? "column",
                alignItems: props.center ? "center" : "inherit",
                textAlign: props.center ? "center" : "inherit",
                minWidth: props.minWidth ?? "inherit",
                maxHeight: props.maxHeight ?? "inherit",
                minHeight: props.minHeight ?? "inherit",
                height: props.height ?? "inherit",
                width: props.width ?? "inherit"
            }}>
            <>
                {title ? (
                    typeof title === "string" ? (
                        <Typography sx={{ pb: 1 }} variant="h5">
                            {title}
                        </Typography>
                    ) : (
                        title
                    )
                ) : undefined}

                {value}
            </>
        </Paper>
    );
}
